// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/stripe_account.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message fingertip.common.type.v1.StripeAccountRequirementsError
 */
export const StripeAccountRequirementsError = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StripeAccountRequirementsError",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "requirement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StripeAccount
 */
export const StripeAccount = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StripeAccount",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "capabilities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 3, name: "charges_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "details_submitted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "payouts_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "errors", kind: "message", T: StripeAccountRequirementsError, repeated: true },
  ],
);

